export const styles = {
  mobileSetupPageContainer: {
    padding: '1rem 3rem',
  },
  mobileSetupEmailFormButton: {
    margin: '10px 0 0 1rem',
  },
};
